import { Action } from 'redux'

export const CLEAR_OFFER_ACTIVITIES = 'CLEAR_OFFER_ACTIVITIES'

export type ClearOfferActivities = Action<typeof CLEAR_OFFER_ACTIVITIES>

export type ActivitiesAction = ClearOfferActivities
